import { createTypes, actionCreator } from 'redux-action-creator';

export const employerTypes = createTypes(['SET_EMPLOYER', 'REMOVE_EMPLOYER', 'CLEAR_VIDT_EMPLOYERS'], 'EMPLOYERS');


export const removeEmployer = (customerId, employerId) => {
    return {
        type: employerTypes.REMOVE_EMPLOYER,
        customerId: customerId,
        employerId: employerId,
    };
};

export const createEmployer = (customerId, employer, startDate) => {
    return {
        type: employerTypes.SET_EMPLOYER,
        customerId: customerId,
        employer: employer,
        startDate: startDate,
    };
};

export const clearVidtEmployers = (customerId) => {
    return {
        type: employerTypes.CLEAR_VIDT_EMPLOYERS,
        customerId: customerId,
    }; 
}